import { createAction } from 'redux-actions';

import { getActions } from '@elab/components/connected/forms/DatepickerCalendar/redux';

import types, { storeName } from './types';

export const { focusField, blurField, resetData, setDataFieldValue } = getActions(storeName);

export const setPageSize = createAction(types.SET_PAGE_SIZE, pageSize => ({
    pageSize,
}));

export const updateLoyaltyCardHistoryList = createAction(types.UPDATE_LOYALTY_CARD_HISTORY_LIST);
export const resetRecords = createAction(types.RESET_RECORDS);
